<template>
    <div>
        <div class="imageContainer" @click="open()">
            <div class="text-center uppercase">
                {{ $t('localization') }}

                <p>
                    <icon icon="map"></icon>
                </p>

                {{ $t('view_in_the_map') }}
            </div>
        </div>
    </div>
</template>

<style scoped>
    .imageContainer {
        padding: 30px;
        width: 100%;
        height: auto;
        vertical-align: center;
        cursor: pointer;
    }
</style>

<script>
    export default {
        props: {
            message: Object,
            instanceId: String
        },

        data() {
            return {

            }
        },

        methods: {
            open() {
                let viewpoint = this.message.content.lat + ',' + this.message.content.lon;
                let url = "https://www.google.com/maps/@?api=1&map_action=search&viewpoint=" + viewpoint;

                window.open(url, '_blank');
            }
        }
    }
</script>
